import { render } from "./PlaceOrder.vue?vue&type=template&id=b7a12976&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b7a12976"

export default script